import request from "@/utils/request";
// 骑手提现列表
export function widthdrawalList(params) {
    return request({
        url: "delivery/rider/finance-list",
        method: "get",
        params,
    });
}
// 骑手提现列表
export function getwidthdrawal(params) {
    return request({
        url: "delivery/rider/finance-info",
        method: "get",
        params,
    });
}
// 骑手提现操作
export function withdrawalOperation(data) {
    return request({
        url: "delivery/rider/modify-finance",
        method: "post",
        data,
    });
}
//资产总览
export function platformAssets(data) {
    return request({
        url: "delivery/finance/platform-assets",
        method: "post",
        data,
    });
}
//商户资产总览
export function storeAssets(params) {
    return request({
        url: "delivery/finance/store-assets",
        method: "get",
        params,
    });
}
//商户储值统计
export function storeStatistics(params) {
    return request({
        url: "delivery/finance/store-statistics",
        method: "get",
        params,
    });
}
//骑手资产总览
export function riderAssets(params) {
    return request({
        url: "delivery/finance/rider-assets",
        method: "get",
        params,
    });
}